import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const AUTO_REFRESH_STORAGE_KEY = 'ai-qc-documents-auto-refresh';

@Injectable({
  providedIn: 'root',
})
export class AutoRefreshSettingsService {
  private readonly enabledSubject = new BehaviorSubject<boolean>(this.readPreference());
  public readonly enabled$ = this.enabledSubject.asObservable();

  public get enabled(): boolean {
    return this.enabledSubject.value;
  }

  public setEnabled(enabled: boolean): void {
    try {
      localStorage.setItem(AUTO_REFRESH_STORAGE_KEY, String(enabled));
    } catch {
      // The preference remains session-only when browser storage is unavailable.
    }
    this.enabledSubject.next(enabled);
  }

  private readPreference(): boolean {
    try {
      return localStorage.getItem(AUTO_REFRESH_STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  }
}
